import React, { useState } from "react";
import Card from "../CardTablesEditor/Card";

interface SimpleEditObjectProps {
    createObject: Function;
    saveObject: Function;
    newObject?: boolean;
    quiz_object?: any;
    fields: Array<string>;
    i: number;
    editable?: boolean;
}

const errorMessage = (details: any) => {
    if (typeof details === "string") return details;
    return details?.error || details?.detail || "Could not save this card.";
};

export const persistQuizObject = (
    quizObject: any,
    createObject: Function,
    saveObject: Function,
    callback: Function,
) => {
    const persist = quizObject._id ? saveObject : createObject;
    return persist(quizObject, callback);
};

const SimpleEditObject = function({
    createObject,
    saveObject,
    fields,
    newObject,
    quiz_object,
    i,
    editable = true,
}: SimpleEditObjectProps) {
    const [saving, setSaving] = useState(false);
    const [saveError, setSaveError] = useState<string | null>(null);

    const update = () => {
        setSaving(true);
        setSaveError(null);

        persistQuizObject(quiz_object, createObject, saveObject, (failed: boolean, details: any) => {
            setSaving(false);
            if (failed) setSaveError(errorMessage(details));
        });
    };

    return (
        <Card
            card={quiz_object}
            fields={fields}
            saving={saving}
            saveError={saveError}
            editable={editable}
            update={update}
            newObject={newObject}
            i={i}
        />
    );
};

export default SimpleEditObject;
